import React, { Component } from 'react';
//import Headroom from 'react-headroom';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Grid, Row, css, styled, withTheme, up } from '@smooth-ui/core-sc';
import HeaderLogo from 'theme/NavHeader@2x.jpg';

const CustomHeadroom = styled.div`
  .logo-background {
    background: linear-gradient(90deg, #fff 0%, #fff 30%, #034ea2 30%);
  }

  .blue-background {
    background: #034ea2;
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  background: linear-gradient(90deg, #fff 0%, #fff 25%, #034ea2 25%);

  ${up(
    'md',
    css`
      background: linear-gradient(90deg, #fff 0%, #fff 15%, #034ea2 15%);
    `
  )}

  ${up(
    'xl',
    css`
      background: linear-gradient(90deg, #fff 0%, #fff 30%, #034ea2 30%);
    `
  )}
`;

const HeaderWrapper = styled.div`
  border-top: 15px solid #034ea2;
  padding: 0;
  width: 100%;

  .sui-row {
    height: 94px;
  }
`;

const LogoLink = styled(Link)`
  width: 269px;
  height: 94px;
  position: absolute;
  left: 0;
  bottom: 0;

  ${up(
    'lg',
    css`
      background: white;
    `
  )}

  img {
    height: 94px;
    width: 269px;
  }
`;

const HeaderRightContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-bottom: 5px;

  ${up(
    'lg',
    css`
      flex-direction: column;
    `
  )}
`;

class Header extends Component {
  render() {
    return (
      <header className="site-header">
        {/* Leave the above <header /> here, necessary to contain Headroom */}
        {/* Otherwise Headroom will wrap all sibling elements */}
        <CustomHeadroom disableInlineStyles downTolerance={10}>
          <HeaderWrapper className="header-wrapper">
            <Grid>
              <Row justifyContent="center" className="relative">
                <LogoLink to="/">
                  <img src={HeaderLogo} alt="Epson Premium Partner Rewards" />
                </LogoLink>
                <div className="blue-background">
                  <HeaderRightContainer>
                    {this.props.children}
                  </HeaderRightContainer>
                </div>
              </Row>
            </Grid>
          </HeaderWrapper>
        </CustomHeadroom>
      </header>
    );
  }
}

Header.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.object,
};

Header.defaultProps = {
  children: undefined,
  theme: undefined,
};

export default withTheme(Header);
